<mbs-modal [isCustomModal]="true"
           [title]="'wizards:schedule.additionalModal.title' | i18next">
  <ng-container modal-body
                [formGroup]="form">
    <mbs-form-group>
      <!-- First backup starts on -->
      <div class="row">
        <div class="col-3">
          <mbs-input-label class="mbs-form_label mb-0"
                           [label]="'wizards:schedule.additionalModal.startFromDate' | i18next"></mbs-input-label>
        </div>
        <div class="col-3 mt-n1">
          <mbs-datepicker formControlName="startFromDate"
                          [needSetCurrent]="true"
                          [id]="elementSelectors.id.startFromDate"></mbs-datepicker>
        </div>
      </div>
      <!-- Stop Backup After -->
      <div class="row mt-3">
        <div class="col-5 pr-0">
          <mbs-checkbox formControlName="StopAfterEnabled"
                        (change)="stopAfterEnabledChangeHandler($event)"
                        [label]="'wizards:schedule.additionalModal.stopBackupCheckbox' | i18next"
                        [id]="elementSelectors.id.stopAfterCheckbox"></mbs-checkbox>
        </div>
        <div class="col-2 mt-n1">
          <mbs-number formControlName="stopAfterHours"
                      min="0"
                      (change)="stopAfterHoursChangeHandler($event)"
                      [id]="elementSelectors.id.stopAfterHours"></mbs-number>
        </div>
        <div class="col-auto">
          <mbs-input-label class="mbs-form_label mb-0"
                           [label]="'wizards:schedule.additionalModal.hours' | i18next"></mbs-input-label>
        </div>
        <div class="col-2 mt-n1">
          <mbs-number formControlName="stopAfterMinutes"
                      min="0"
                      max="59"
                      [id]="elementSelectors.id.stopAfterMinutes"></mbs-number>
        </div>
        <div class="col-auto">
          <mbs-input-label class="mbs-form_label mb-0"
                           [label]="'wizards:schedule.additionalModal.minutes' | i18next"></mbs-input-label>
        </div>
      </div>
      <!-- Alert Backup as overdue after -->
      <div *ngIf="!isRDMode"
           [id]="elementSelectors.id.alertOverdueBlock"
           class="row mt-3">
        <div class="col-5 pr-0">
          <mbs-checkbox formControlName="overdueAfterSuccessEnabled"
                        (change)="overdueAfterSuccessChangeHandler($event)"
                        [label]="'wizards:schedule.additionalModal.overdueCheckbox' | i18next"
                        [id]="elementSelectors.id.alertOverdueCheckbox"></mbs-checkbox>
        </div>
        <div class="col-2 mt-n1">
          <mbs-number formControlName="overdueAfterSuccessAmount"
                      min="1"
                      [id]="elementSelectors.id.alertOverdueDays"></mbs-number>
        </div>
        <div class="col-2 mt-n1">
          <mbs-select formControlName="overdueAfterSuccessPeriod"
                      [bindValue]="'value'"
                      [bindLabel]="'label'"
                      [clearable]="false"
                      [hideSelected]="true"
                      [items]="overduePeriod"
                      [id]="elementSelectors.id.alertOverduePeriod"
                      [searchable]="false"></mbs-select>
        </div>
        <div class="col-auto">
          <mbs-input-label class="mbs-form_label mb-0"
                           [label]="'wizards:schedule.additionalModal.overduePostfix' | i18next"></mbs-input-label>
        </div>
      </div>
      <!-- Run missed Backup immediately when the computer starts up -->
      <div class="row mt-3">
        <div class="col-auto">
          <mbs-checkbox formControlName="ForceMissedSchedule"
                        [label]="'wizards:schedule.additionalModal.forceMissedEnabled' | i18next"
                        [id]="elementSelectors.id.forceMissedCheckbox"></mbs-checkbox>
        </div>
      </div>
    </mbs-form-group>
  </ng-container>

  <ng-container modalFooter>
    <button type="button"
            class="btn btn-primary"
            [attr.data-test-element]="elementSelectors.id.saveButton"
            [disabled]="form.invalid"
            (click)="saveClickHandler()">{{ 'shared:buttons.save' | i18next: { format: 'title' } }}</button>
    <button type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            [attr.data-test-element]="elementSelectors.id.cancelButton"
            (click)="cancelClickHandler()">{{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}</button>
  </ng-container>
</mbs-modal>
